export default [
    {
        'text': 'Mr.',
        'value': 'Mr.'
    },
    {
        'text': 'Ms.',
        'value': 'Ms.'
    },
    {
        'text': 'Mrs.',
        'value': 'Mrs.'
    },
    {
        'text': 'Dr.',
        'value': 'Dr.'
    },
    {
        'text': 'Other',
        'value': -1
    }
];
